import React from "react";
import { Link } from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const HomeAbout = () => {
  return (
    <div className="edu-about-area about-style-2 edu-section-gap bg-color-white py-12">
      <div className="container max-w-6xl mx-auto px-4">
        <div className="row flex flex-wrap justify-center items-center">
          {/* Left Side - Round Image */}
          <div className="col-lg-6 flex justify-center order-2 md:order-1 p-4">
            <div className="about-image-gallery relative">
              <div
                className="image-wrapper relative w-[350px] h-[350px] rounded-full overflow-hidden mx-auto z-30"
              >
                <img
                  src="./image/about/about-07/about1.png"
                  alt="About Us"
                  className="w-full h-full object-cover rounded-full"
                />
              </div>

              {/* Small Circular Box - Sessions */}
              <div
    className="finished-session absolute left-[50px] top-[-50px] w-[100px] h-[100px] bg-white rounded-full flex justify-center items-center shadow-lg z-30"
>
  <div className="inner text-center">
    <div className="text text-[20px] font-bold text-gray-800">2.98K</div>
    <span className="finished-title text-[12px] font-semibold text-gray-600">
      Finished <br /> Sessions
    </span>
  </div>
</div>

            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="col-lg-6 flex-1 p-4 order-1 md:order-2 text-left">
            <div className="inner">
            <div id="welcome-to-fetc" className="mt-12">
  <h2 className="section-title text-[36px] font-extrabold text-gray-900 mb-2">
    Welcome to FETC
  </h2>
</div>

              <p className="pre-title text-[#489ec4] text-[14px] font-extrabold uppercase tracking-wider mb-5">
                Powered By Gina Abroad
              </p>

              {/* Features */}
              <div>
                {/* Feature 1 */}
                <div className="edu-feature-list flex items-center mb-5">
                  <div className="icon w-[40px] h-[40px] mr-3">
                    <img
                      src="./image/about/about-05/student.png"
                      alt="Student Training"
                      className="w-full h-full"
                    />
                  </div>
                  <div className="content">
                    <h6 className="title text-[18px] font-semibold text-gray-900 mb-2">
                      English Language Training
                    </h6>
                    <p className="description text-[14px] text-gray-600">
                      Blended & Hybrid training structure to assist maximum proximity to teaching worldwide.
                    </p>
                  </div>
                </div>

                {/* Feature 2 */}
                <div className="edu-feature-list flex items-center mb-5">
                  <div className="icon w-[40px] h-[40px] mr-3">
                    <img
                      src="./image/about/about-05/book.png"
                      alt="Authorized Exam Centre"
                      className="w-full h-full"
                    />
                  </div>
                  <div className="content">
                    <h6 className="title text-[18px] font-semibold text-gray-900 mb-2">
                      Authorized Exam Centre
                    </h6>
                    <p className="description text-[14px] text-gray-600">
                      We provide official testing services for various international language examinations.
                    </p>
                  </div>
                </div>

                {/* Feature 3 */}
                <div className="edu-feature-list flex items-center mb-5">
                  <div className="icon w-[40px] h-[40px] mr-3">
                    <img
                      src="./image/about/about-05/reward.png"
                      alt="Study Abroad"
                      className="w-full h-full"
                    />
                  </div>
                  <div className="content">
                    <h6 className="title text-[18px] font-semibold text-gray-900 mb-2">
                      Study Abroad
                    </h6>
                    <p className="description text-[14px] text-gray-600">
                      Expert support in program selection, application processes, and visa requirements.
                    </p>
                  </div>
                </div>
              </div>

              <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                <Link
                  className="edu-btn inline-block text-[16px] font-semibold py-[15px] px-[30px] bg-[#fb7c56] text-white rounded-md transition-all mt-5 mb-10"
                  to="/about-us"
                >
                  Explore FETC's Mission{" "}
                  <i className="icon-arrow-right-line-right"></i>
                </Link>
              </ScrollAnimation>
            </div>
          </div>
        </div>

        {/* Bottom Box */}
        <div className="bg-gray-200 my-10 mb-1 text-[16px] font-semibold leading-[1.8] text-black w-full max-w-4xl p-6 rounded-2xl shadow-md border border-gray-300 text-center mx-auto flex items-center justify-center min-h-[10vh]">
        Embrace all the verticals related to education — from Career counselling, Language Enhancement, and curbing a roadmap of students' future in course selection and placement.
        </div>
      </div>
    </div>
  );
};

export default HomeAbout;
